import type { Components } from '@mui/material';
import { switchClasses } from '@mui/material';

export const MuiSwitch: Components['MuiSwitch'] = {
  styleOverrides: {
    root: {
      padding: 7,
      [`& .${switchClasses.checked}`]: {
        [`& .${switchClasses.thumb}`]: {
          backgroundColor: 'white',
        },
        [`+ .${switchClasses.track}`]: {
          backgroundColor: '#458FFF !important',
          opacity: '1 !important',
        },
      },
    },
    track: {
      borderRadius: 24,
      backgroundColor: '#D1D8DB',
      opacity: 1,
    },
    thumb: {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  },
};